export enum LinksConstrains {
  CALL_CENTER_APP = "/call-center",
  CALL_CENTER_ITEMS = "/call-center/items",
  CALL_CENTER_ORDERS = "/call-center/orders",
  CALL_CENTER_ORDERS_HISTORY = "/call-center/history/orders",
  CALL_CENTER_CUSTOMERS = "/call-center/customers",
  CALL_CENTER_CREATE_ORDER = "/call-center/orders#create-order",
  CALL_CENTER_EDIT_ORDER = "/call-center/orders#edit-order&tabId=:tab_id&locationId=:location_id&isReorder=:isReorder",
  CALL_CENTER_DASHBOARD = "/call-center/dashboard",
  CALL_CENTER_CHAT = "/call-center/communications",

  OOC = "/ooc",
  OOC_LOGIN = "/ooc/login",
  OOC_DASHBOARD = "/ooc/dashboard",
  OOC_INTEGRATION = "/ooc/integration",
  OOC_MERCHANTS = "/ooc/merchants",
  OOC_MENUS = "/ooc/merchants/:businessId/menus/:locationId",
  OOC_ORDERS = "/ooc/orders",

  OOC_MENU_INTEGRATION = "/ooc/menus/:businessId/integration-location/:selectedIntegration",

  ORDERS = "/orders",
  CUSTOMERS = "/customers",
  SETTINGS = "/settings",
  SETTINGS_BUSINESS_LOCATION = "/settings/business/location",
  SETTINGS_BUSINESS_LOCATION_DIGITAL_MENU = "/settings/business/location/:menuId",
  SETTINGS_CASH_AND_PAYMENT_EXTRA_CHARGES = "/settings/cash-and-payment/extra-charges",
  SETTINGS_CASH_AND_PAYMENT_DISCOUNTS = "/settings/cash-and-payment/discounts",
  SETTINGS_CASH_AND_PAYMENT_TAXES = "/settings/cash-and-payment/taxes",
  SETTINGS_CASH_AND_PAYMENT_CURRENCIES = "/settings/cash-and-payment/currencies",
  SETTINGS_BUSINESS_DEVICES = "/settings/business/devices",
  SETTINGS_ACCOUNT_SETTINGS = "/settings/accounts/",
  SETTINGS_ACCOUNT_SETTINGS_CALL_CENTER = "/settings/accounts/call-center",
  SETTINGS_ACCOUNT_SETTINGS_SUBSCRIPTION_AND_BILLING = "/settings/account/subscription_and_billing",
  SETTINGS_ACCOUNT_SETTINGS_INTEGRATIONS = "/settings/account/integrations",
  SETTINGS_BUSINESS_DRIVER = "/settings/business/drivers",
  SETTINGS_BUSINESS_ORDER_SOURCE = "/settings/business/order-source",
  SETTINGS_BUSINESS_SALES_OPTION = "/settings/business/sales-option",
  SETTINGS_BUSINESS_UNITS = "/settings/business/units",
  SETTINGS_BUSINESS_DETAILS = "/settings/business/business-details",
  SETTINGS_CASH_AND_PAYMENT_PAY_IN_OUT = "/settings/cash-and-payment/pay-in-out",
  
  CATALOG = "/catalog",
  CATALOG_ITEMS = "/catalog/items",
  CATALOG_CATEGORIES = "/catalog/categories",
  CATALOG_COMBOS = "/catalog/combos",
  CATALOG_MODIFIERS_LIST = "/catalog/modifiers-list",
  CATALOG_RECIPES_BOOK = "/catalog/recipes-book",
  ACCESS_DENIED = "/access-denied",
  LOGIN = "/login",
  LOGOUT = "/logout",
}
